import 'yet-another-react-lightbox/styles.css';

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Box, Stack } from '@mui/material';
import Lightbox from 'yet-another-react-lightbox';

import BaseImage from '../../../DesignSystem/BaseImage';
import AttachmentLink from '../AttachmentLink/AttachmentLink';
import { cloudinaryImageUrl } from '../../../../Services/Cloudinary';

function AttachmentLinksList({ attachments = [], ...rest }: any) {
  const imageAttachments =
    attachments.filter((attachment: any) => attachment.type.includes('image')) || [];
  const otherAttachments = attachments.filter(
    (attachment: any) => !imageAttachments.includes(attachment),
  );
  const [currentIndex, setCurrentIndex] = useState(-1);

  let imagesComponent;

  if (!otherAttachments.length && !imageAttachments.length) {
    return null;
  }

  if (imageAttachments.length) {
    imagesComponent = (
      <>
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          sx={{
            flexWrap: 'wrap',
            mb: 4,
          }}
        >
          {imageAttachments.map((attachment: any, index: any) => (
            <Box
              sx={{ cursor: 'zoom-in', width: '200px', height: '200px' }}
              key={`attachment-${attachment.id}`}
            >
              <BaseImage
                src={cloudinaryImageUrl(
                  attachment.s3_key,
                  'h_200,w_200,c_fill,q_auto:eco',
                  attachment.title,
                )}
                ratio="1:1"
                alt={attachment.title}
                onClick={() => setCurrentIndex(index)}
                rounded
              />
            </Box>
          ))}
        </Stack>
        <Lightbox
          index={currentIndex}
          slides={imageAttachments.map((attachment: any) => {
            return {
              src: cloudinaryImageUrl(attachment.s3_key),
            };
          })}
          open={currentIndex >= 0}
          close={() => setCurrentIndex(-1)}
        />
      </>
    );
  }

  return (
    <Box role="list" sx={{ my: 3 }}>
      {otherAttachments.map((attachment: any) => (
        <Box key={attachment.s3_key || attachment.blob_key} role="listitem" sx={{ mb: 2 }}>
          <AttachmentLink attachment={attachment} {...rest} />
        </Box>
      ))}
      {imagesComponent}
    </Box>
  );
}

AttachmentLinksList.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      size: PropTypes.number,
      title: PropTypes.string,
    }),
  ),
  noPreview: PropTypes.bool,
};

export default AttachmentLinksList;
